import React, { Suspense, useEffect, useState } from 'react';
import './App.css';
import './fonts/stylesheet.css';
import Loader from './components/Loader/Loader';

const Memory = React.lazy(()=> import('./components/memory/Memory.jsx'))
const Morpion = React.lazy(()=> import('./components/morpion/Morpion.jsx'))

const App = () =>{
  const [scale, setScale] = useState(1);
  const [datas, setDatas] = useState(null);
  const [error, setError] = useState(null);


  let game = process.env.REACT_APP_GAMETYPE
  let name = process.env.REACT_APP_GAMENAME

  // dev memory
  // game = "memory"
  // name = "art"
  // name = "cuisine"
  // name = "maison"
  // name = "medias"
  // name = "oiseaux"

  // dev morpion
  // game = "morpion"
  // name = "animaux"
  // name = "astronomie"
  // name = "fetes"
  // name = "instruments"
  // name = "transports"

  useEffect(() => {
    const calculateScale = () => {
      let appRatio = 800 / 600
      let windowWidth = window.innerWidth
      let windowHeight = window.innerHeight
      let windowRatio = windowWidth / windowHeight; /* browser size */
      let scale
      if (windowRatio < appRatio) { //
        scale = windowWidth / 800
      } else { // vertical
        scale = windowHeight / 600
      }

      scale = Math.min(scale, 1)

      // HACK :)
      window.appScale = scale

      setScale(scale)
    }

    window.addEventListener('resize', calculateScale)

    return () => window.removeEventListener('resize', calculateScale)
  }, []);


  useEffect(() => {
    let filePath = `./data/${game}/${name}.json`

    fetch(filePath)
    .then(res => res.json())
    .then(d => setDatas(d))
    .catch(err => setError(err))

  }, []);


  return (
    <div id="App" className="App" style={{ transform: `scale(${scale})` }}>
      {game === "memory" && datas &&
      <Suspense fallback={<Loader />}>
        <Memory data={datas.data} title={datas.title} />
      </Suspense>}


      {game === "morpion" && datas &&
      <Suspense fallback={<Loader />}>
        <Morpion data={datas.data} title={datas.title} />
      </Suspense>}

      {error && <div className="error">{error}</div>}
    </div>
  )
}

export default App;
